/*
 *  -----------------------------------------------------------------------
 *    <copyright file="logger.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import * as log from 'loglevel';

const { environment } = window;

log.setDefaultLevel('trace');

const Logger = {
    log: (...props: any[]) => {
        if ((environment as string)?.toLowerCase()?.indexOf('prod') < 0) console.log(...props);
    },
    warn: (...props: any[]) => {
        if ((environment as string)?.toLowerCase()?.indexOf('prod') < 0) console.warn(...props);
    },
    error: (...props: any[]) => {
        console.error(...props);
    },
};

const Log = {
    setLevel: (level: any, save: boolean) => log.setLevel(level, save),
    log: (msg: any) => log.info(msg),
    trace: (msg: any) => log.trace(msg),
    debug: (msg: any) => log.debug(msg),
    info: (msg: any) => log.info(msg),
    warn: (msg: any) => log.warn(msg),
    error: (msg: any) => log.error(msg),
};

// Hack so we can change log levels in the browser console
// @ts-ignore
window.logger = Log;

export { Logger };

export default Log;
